import React, { useEffect, useState } from "react";
import MatrixField from "./MatrixField";
import { matrixFieldsActions, useSelector } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import t from "../../../helpers/t";
import _ from "lodash";

const MatrixFields = (props) => {
  const _matrix_field = useSelector((state) => state.matrix_fields_data.editMatrixField);
  const [matrixFieldPending, setMatrixFieldPending] = useState(false);
  const [matrixFieldsPending, setMatrixFieldsPending] = useState(false);
  const [matrixField, setMatrixField] = useState(null);
  const { matrixFields, setMatrixFields, dispatch, type, showChangeView } = props;
  const [tempMatrixFields, setTempMatrixFields] = useState(null);
  const [startContainer, setStartContainer] = useState(null);
  const [currentContainer, setCurrentContainer] = useState(null);

  let temp = matrixFields;
  if (typeof matrixFields === "object") {
    temp = [];
    Object.keys(matrixFields).map((key) => {
      temp.push(matrixFields[key]);
    });
    // setMatrixFields(temp);
  }
  let highestNumber = 0;
  temp.map((m) => {
    if (m.sort > highestNumber) {
      highestNumber = m.sort;
    }
  });

  const template = {
    client_id: Biscuit.get("user.client_id"),
    name: "",
    active: true,
    required: false,
    pattern: "",
    model: "",
    allowed_domain: "",
    sort: highestNumber + 1,
    allow_foreign_domains: false,
    type: "",
    display_name: "",
    line_break: false,
    webname: "default",
    form_body: "",
    active_be: true,
    required_be: false,
  };
  let language = Biscuit.get("user.lang").replace("-", "_");

  useEffect(() => {
    if (!matrixFieldPending || _matrix_field.success === "") {
      return;
    }
    if (_matrix_field.success === true) {
      setMatrixField(_matrix_field.data);
    } else {
      console.log("Failed editing matrix field!");
    }
    setMatrixFieldPending(false);
  }, [_matrix_field]);

  useEffect(() => {
    if (tempMatrixFields === null) {
      return;
    }
    tempMatrixFields.map((matrixF) => {
      delete matrixF.created;
      delete matrixF.deleted;
      delete matrixF.created_by;
      delete matrixF.modified_by;
      dispatch(
        matrixFieldsActions.editMatrixField({
          token: Biscuit.get("token"),
          matrix_field_id: matrixF.id,
          data: matrixF,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    });
  }, [tempMatrixFields]);

  const onChange = (index, value) => {
    let clone = {};
    Object.assign(clone, matrixFields);
    clone[index] = value;
    setMatrixFields(value);
    if (typeof matrixFields[index].id !== "undefined") {
      dispatch(
        matrixFieldsActions.editMatrixField({
          token: Biscuit.get("token"),
          matrix_field_id: matrixFields[index].id,
          data: value,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    } else {
      dispatch(
        matrixFieldsActions.addMatrixField({
          token: Biscuit.get("token"),
          data: value,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
  };
  const onChangeSortOrder = (index, value) => {
    let clone = {};
    Object.assign(clone, matrixFields);
    clone[index].sort = value;
    setMatrixFields(clone);
    if (typeof matrixFields[index].id !== "undefined") {
      dispatch(
        matrixFieldsActions.editMatrixField({
          token: Biscuit.get("token"),
          matrix_field_id: matrixFields[index].id,
          data: {
            sort: value,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
  };
  const onRemove = (index) => {
    let clone = {};
    Object.assign(clone, matrixFields);
    delete clone[index];
    setMatrixFields(clone);
    if (typeof matrixFields[index].id !== "undefined") {
      dispatch(
        matrixFieldsActions.deleteMatrixField({
          token: Biscuit.get("token"),
          matrix_field_id: matrixFields[index].id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
  };
  const onAdd = () => {
    let clone = {};
    Object.assign(clone, matrixFields);
    clone.push(template);
    setMatrixFields(clone);
  };

  /*draggables.forEach(draggable => {
        draggable.addEventListener('dragstart', () => {
            draggable.classList.add('dragging')
        })

        draggable.addEventListener('dragend', () => {
            draggable.classList.remove('dragging')
        })
    })*/

  //const space =();

  const addSpace = (e) => {
    let element = document.getElementById(e);
    var div = document.createElement("div");
    div.style.visibility = "hidden";
    div.innerHTML = "&nbsp;";
    div.className =
      "inb-c-item inb-c-item--matrix-field-empty medium-5 small-12 column hide-for-small-only";
    element.parentNode.insertBefore(div, element.nextSibling);
  };

  const removeSpace = (e) => {
    let element = document.getElementById(e);
    element.nextElementSibling.remove();
  };

  const touchMove = (e) => {
    let container = document.getElementById(e.currentTarget.id);
    setCurrentContainer(container);
    const afterElement = getDragAfterElement(container, e.clientY);
    const draggable = document.querySelector(".dragging");
    if (afterElement == null) {
      container.appendChild(draggable);
    } else {
      afterElement.classList.add("left-green-border");
      container.insertBefore(draggable, afterElement);
    }
  };

  const dragOver = (e) => {
    e.preventDefault();
    let container = document.getElementById(e.currentTarget.id);
    setCurrentContainer(container);
    const afterElement = getDragAfterElement(container, e.clientY);
    const draggable = document.querySelector(".dragging");
    if (afterElement == null) {
      container.appendChild(draggable);
    } else {
      afterElement.classList.add("left-green-border");
      container.insertBefore(draggable, afterElement);
    }
  };

  const startDrag = (e) => {
    e.target.classList.add("dragging");
    setStartContainer(document.getElementById(e.currentTarget.id));
  };

  const endDrag = (e) => {
    e.target.classList.remove("dragging");
    if (currentContainer.id === "activated_matrixfields") {
      e.target.classList.remove("medium-12");
      e.target.classList.add("medium-5");
    } else {
      e.target.classList.remove("medium-5");
      e.target.classList.add("medium-12");
    }
    let el = document.getElementById("inb-c-main-matrix-fields");
    let allElements = el.querySelectorAll(".dragable");
    allElements.forEach((el) => {
      //el.classList.remove('green-border');
    });
    change();
  };

  const change = () => {
    let element = document.getElementById("activated_matrixfields");
    let count = 0;
    let activeElements = element.querySelectorAll(".dragable");
    let newMatrixFields = [];
    activeElements.forEach((el) => {
      if (typeof el.id !== "undefined") {
        let mF = _.find(matrixFields, function (obj) {
          return obj.id === Number(el.id.replace("mF", ""));
        });
        let newMf = {};
        if (type === "user") {
          if (mF.sort !== count) {
            newMf.id = mF.id;
            newMf.sort = count;
          }
          if (!mF.active) {
            newMf.id = mF.id;
            newMf.active = true;
          }
        }
        if (type === "admin") {
          if (!mF.active_be) {
            newMf.id = mF.id;
            newMf.active_be = true;
          }
        }
        count++;
        if (typeof newMf.id !== "undefined") {
          newMatrixFields.push(newMf);
        }
      }
    });
    let element2 = document.getElementById("deactivated_matrixfields");
    let inactiveElements = element2.querySelectorAll(".dragable");
    count = 100;
    inactiveElements.forEach((el) => {
      if (typeof el.id !== "undefined") {
        let mF = _.find(matrixFields, function (obj) {
          return obj.id === Number(el.id.replace("mF", ""));
        });
        let newMf = {};
        if (type === "user") {
          if (mF.sort !== count) {
            newMf.id = mF.id;
            newMf.sort = count;
          }
          if (mF.active) {
            newMf.id = mF.id;
            newMf.active = false;
          }
        }
        if (type === "admin") {
          if (mF.be_active) {
            newMf.id = mF.id;
            newMf.be_active = false;
          }
        }
        count++;
        if (typeof newMf.id !== "undefined") {
          newMatrixFields.push(newMf);
        }
      }
    });
    setTempMatrixFields(newMatrixFields);
  };

  const enterDrag = (e) => {
    if (!e.target.classList.contains("dragging") && e.target.classList.contains("inb-c-item")) {
      e.target.classList.add("green-border");
    }
  };

  const leaveDrag = (e) => {
    e.target.classList.remove("green-border");
  };
  return (
    <>
      <div className="off-canvas-wrapper">
        <div id="inb-c-main-matrix-fields" className="row" data-off-canvas-content="">
          <div className="medium-9 small-12">
            <label className="padddingLeft40">{t("activated elements")}</label>
            <div
              id="activated_matrixfields"
              className="row dropable"
              onDragOver={dragOver}
              onTouchMove={touchMove}
            >
              {temp.map(function (item, index) {
                if ((type === "user" && item.active) || (type === "admin" && item.active_be)) {
                  return (
                    <>
                      <div
                        className="inb-c-item inb-c-item--product medium-5 small-12 column dragable"
                        draggable="true"
                        onDragStart={startDrag}
                        onDragEnd={endDrag}
                        onDragEnter={enterDrag}
                        onDragLeave={leaveDrag}
                        onTouchStart={startDrag}
                        onTouchEnd={endDrag}
                        key={item.id}
                        id={"mF" + item.id}
                      >
                        <MatrixField
                          item={item}
                          index={index}
                          count={highestNumber}
                          onChange={onChange}
                          onChangeSortOrder={onChangeSortOrder}
                          onRemove={onRemove}
                          addSpace={addSpace}
                          removeSpace={removeSpace}
                          setMatrixFields={setTempMatrixFields}
                          matrixFields={matrixFields}
                          tempMatrixFields={tempMatrixFields}
                          type={type}
                          showChangeView={showChangeView}
                          dispatch={props.dispatch}
                          subpanel={props.subpanel}
                        />
                        <div className="Pattern Pattern--typeHalftone"></div>
                        <div className="Pattern Pattern--typePlaced"></div>
                      </div>
                      {type === "user" && item.line_break && (
                        <>
                          <div
                            className="inb-c-item inb-c-item--matrix-field-empty medium-5 small-12 column hide-for-small-only"
                            style={{ visibility: "hidden" }}
                          >
                            &nbsp;
                          </div>
                        </>
                      )}
                    </>
                  );
                }
              })}
            </div>
          </div>
          <div className="medium-3 small-12 dotted-grey-border" style={{}}>
            <label className="padddingLeft40">{t("deactivated elements")}</label>
            <div id="deactivated_matrixfields" className="dropable" onDragOver={dragOver}>
              {temp.map(function (item, index) {
                if ((type === "user" && !item.active) || (type === "admin" && !item.active_be)) {
                  return (
                    <>
                      <div
                        className="inb-c-item inb-c-item--product medium-12 small-12 column dragable"
                        draggable="true"
                        onDragStart={startDrag}
                        onDragEnd={endDrag}
                        onDragEnter={enterDrag}
                        onDragLeave={leaveDrag}
                        onTouchStart={startDrag}
                        onTouchEnd={endDrag}
                        key={item.id}
                        id={"mF" + item.id}
                      >
                        <MatrixField
                          item={item}
                          index={index}
                          count={highestNumber}
                          onChange={onChange}
                          onChangeSortOrder={onChangeSortOrder}
                          setMatrixFields={setTempMatrixFields}
                          matrixFields={matrixFields}
                          tempMatrixFields={tempMatrixFields}
                          onRemove={onRemove}
                          type={type}
                          showChangeView={showChangeView}
                          dispatch={props.dispatch}
                          subpanel={props.subpanel}
                        />
                      </div>
                    </>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function getDragAfterElement(container, y) {
  const draggableElements = [...container.querySelectorAll(".dragable:not(.dragging)")];
  const draggables = document.querySelectorAll(".dragable");
  draggables.forEach((element) => {
    element.classList.remove("left-border-green");
  }); //console.log('draggableElements',draggableElements)
  return draggableElements.reduce(
    (closest, child) => {
      const box = child.getBoundingClientRect();
      //console.log('dragOver',box)
      const offset = y - box.top - box.height / 2;
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child };
      } else {
        return closest;
      }
    },
    { offset: Number.NEGATIVE_INFINITY },
  ).element;
}

export default MatrixFields;
